import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import { Divider } from 'components/lib/Divider';
import FilterDropdownHeader from 'components/lib/FilterDropdownHeader';

import CompetitorListSection from './CompetitorListSection';
import CompetitorToggleSection from './CompetitorToggleSection';
import MyCommunitySection from './MyCommunitySection';
import QuarterSelection from './QuarterSelection';
import { useDataQuarterFilterContext } from '../DataQuarterFilterContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 540px;
  max-height: 470px;
  background-color: white;
  border: 1px solid var(--line-gray);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 320px;
`;

const DetailsColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 18px;
`;

const DataQuarterFilterDropdown = () => {
  const { reset } = useDataQuarterFilterContext();

  return (
    <Container onMouseDown={(event) => event.stopPropagation()} onClick={(event) => event.stopPropagation()}>
      <Form.Item name="selectedQuarterSlug" hidden noStyle>
        <input type="hidden" />
      </Form.Item>
      <FilterDropdownHeader onReset={reset} />
      <ContentRow>
        <QuarterSelection />
        <DetailsColumn>
          <MyCommunitySection />
          <CompetitorToggleSection />
          <Divider />
          <CompetitorListSection />
        </DetailsColumn>
      </ContentRow>
    </Container>
  );
};

export default DataQuarterFilterDropdown;
